unit DeviceItemListType;
{

/* Initial. */

}

interface

uses
  DeviceItemType;

type
  TDeviceItemListType = array of TDeviceItemType;

implementation

end.
